<template>
  <div class="row">
    <div class="d-none d-sm-block col-sm-4 mt-5 pt-5">
      <img src="~../../assets/image/pic_plant.png" />
    </div>

    <div class="col-xs-12 col-sm-4 pt-5">
      <h3 class="text-center">{{ title }}</h3>
      <p class="text-center mt-3 w-100 mb-5 pb-5" style="line-height: 300%;">{{ description }}</p>
    </div>

    <div class="d-none d-sm-block col-sm-4 mt-5 pt-5">
      <img src="~../../assets/image/pic_plant.png" />
    </div>
  </div>
</template>

<script>
export default {

  name: 'EmptyPage',

  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },

    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// EmptyPage.vue?57fac75d